﻿/**
* DevExpress Dashboard (_data-source-wizard-page-iterator.js)
* Version:  20.1.8
* Build date: Oct 12, 2020
* Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dx_querybuilder_1 = require("@devexpress/analytics-core/dx-querybuilder");
var page_id_1 = require("../pages/page-id");
var DataSourceWizardPageIteratorBase = (function (_super) {
    __extends(DataSourceWizardPageIteratorBase, _super);
    function DataSourceWizardPageIteratorBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataSourceWizardPageIteratorBase.prototype.getInitialPage = function () {
        return page_id_1.DataSourceWizardPageId.ChooseDataSourceTypePage;
    };
    DataSourceWizardPageIteratorBase.prototype.getNextPageId = function (pageId) {
        if (!pageId) {
            return this.getInitialPage();
        }
        else {
            var currentState = this._getCurrentState();
            switch (pageId) {
                case page_id_1.DataSourceWizardPageId.ChooseDataSourceTypePage:
                    switch (currentState.dashboardDataSourceType) {
                        case 'Sql':
                            return dx_querybuilder_1.default.Analytics.Wizard.SqlDataSourceWizardPageId.ChooseConnectionPage;
                        case 'Olap':
                            return page_id_1.OlapDataSourceWizardPageId.ChooseConnectionPage;
                        case 'Json':
                            return dx_querybuilder_1.default.Analytics.Wizard.JsonDataSourceWizardPageId.ChooseConnectionPage;
                        default:
                            throw new Error('Unknown datasource type.');
                    }
                case dx_querybuilder_1.default.Analytics.Wizard.SqlDataSourceWizardPageId.ChooseConnectionPage:
                    return this.getConfigureQueryPage();
                case dx_querybuilder_1.default.Analytics.Wizard.ObjectDataSourceWizardPageId.ChooseTypesPage:
                    return dx_querybuilder_1.default.Analytics.Wizard.ObjectDataSourceWizardPageId.ChooseDataMembersPage;
                case dx_querybuilder_1.default.Analytics.Wizard.ObjectDataSourceWizardPageId.ChooseDataMembersPage:
                    return dx_querybuilder_1.default.Analytics.Wizard.ObjectDataSourceWizardPageId.ConfigureParametersPage;
                case this.getConfigureQueryPage():
                    return this.getConfigureSqlParametersPage();
                case dx_querybuilder_1.default.Analytics.Wizard.JsonDataSourceWizardPageId.ChooseConnectionPage:
                    if (currentState.jsonDataSourceWizard.connectionName) {
                        return dx_querybuilder_1.default.Analytics.Wizard.JsonDataSourceWizardPageId.ChooseJsonSchemaPage;
                    }
                    else {
                        return dx_querybuilder_1.default.Analytics.Wizard.JsonDataSourceWizardPageId.ChooseJsonSourcePage;
                    }
                case dx_querybuilder_1.default.Analytics.Wizard.JsonDataSourceWizardPageId.ChooseJsonSourcePage:
                    return dx_querybuilder_1.default.Analytics.Wizard.JsonDataSourceWizardPageId.ChooseJsonSchemaPage;
            }
        }
    };
    DataSourceWizardPageIteratorBase.prototype.getConfigureQueryPage = function () {
        return dx_querybuilder_1.default.Analytics.Wizard.SqlDataSourceWizardPageId.ConfigureQueryPage;
    };
    DataSourceWizardPageIteratorBase.prototype.getConfigureSqlParametersPage = function () {
        return dx_querybuilder_1.default.Analytics.Wizard.SqlDataSourceWizardPageId.ConfigureParametersPage;
    };
    DataSourceWizardPageIteratorBase.prototype.getConfigureObjectParametersPage = function () {
        return dx_querybuilder_1.default.Analytics.Wizard.ObjectDataSourceWizardPageId.ConfigureParametersPage;
    };
    return DataSourceWizardPageIteratorBase;
}(dx_querybuilder_1.default.Analytics.Wizard.PageIterator));
exports.DataSourceWizardPageIteratorBase = DataSourceWizardPageIteratorBase;
